export default "__VITE_ASSET__19474c7d__"